import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ToastContainer, toast } from "react-toastify";

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [toggleValue, setToggleValue] = useState(false);
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;
  const [orderDetails, setOrderDetails] = useState();
  const [commissionData, setCommissionData] = useState([]);

  // Fetch commission data
  const getProductCommission = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}order/all-order-product-details`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      setCommissionData(response.data.data);
    } catch (error) {
      console.error("Error" + error);
    }
  };

  // Fetch order details
  const getOrderDetails = async () => {
    try {
      // Check user type, assuming it's stored in localStorage or part of the API response
      const userType = localStorage.getItem("userType"); // or you can check this from the response

      let url = "";
      // Use the correct API endpoint based on the user type
      if (userType === "distributor") {
        url = `${process.env.REACT_APP_API_URL}order/admin/${id}`; // API endpoint for distributor
      } else {
        url = `${process.env.REACT_APP_API_URL}order/user/${id}`; // API endpoint for other user types
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      setOrderDetails(response.data);
    } catch (error) {
      console.error("Error" + error);
    }
  };


  useEffect(() => {
    getOrderDetails();
    getProductCommission();
  }, [id]);

  const date = new Date(orderDetails?.createdAt);
  const formattedDate = date.toLocaleDateString("en-IN");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");

  const reasonsForReturn = [
    "Product is defective",
    "Quality is not good",
    "Received wrong product",
    "Other",
  ];
  const reasonsForCancel = [
    "Ordered by mistake",
    "Found a better price",
    "Changed my mind",
    "Other",
  ];

  const openModal = (type, item) => {
    setModalType(type);
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedReason("");
    setSelectedItem(null);
  };

  const handleSubmitReason = async () => {
    if (!selectedReason.trim()) {
      toast.warn("Please select a reason before submitting.");
      return;
    }
    closeModal();
    const { id: productId } = selectedItem;
    const returnType =
      modalType === "Return" ? "Return Requested" : "Cancelled";
    await handelReturn(orderDetails.id, productId, returnType, selectedReason);
  };

  const handelReturn = async (orderId, productId, returnType) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}order/updateReturnType`,
        { orderId, productId, returnType },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const { message, status } = response.data;
      if (status === "success") {
        toast.success(
          returnType === "Return Requested"
            ? "Return is Processed Successfully!"
            : "Cancelled is Processed Successfully."
        );
        getOrderDetails();
      } else {
        toast.warn(
          message || "An error occurred while processing your request."
        );
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong.";
      toast.error(`Error: ${errorMessage}`);
    }
  };

  // Helper function to calculate commission
  const calculateCommission = (orderId, productId) => {
    const productCommission = commissionData.find(
      (commission) => commission.orderid === orderId && commission.productid === productId
    );

    return productCommission ? productCommission.commission_amount : 0;
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          />
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <h5>Orders Details</h5>
              <h6 className="text-muted">View your order details</h6>
            </div>
            {orderDetails && (
              <div className="col-12 mt-5">
                <section className="content">
                  <div className="container-fluid">
                    <div className="orderdetails bg-light">
                      <div className="row">
                        <div className="col-sm-4 col-md-4">
                          <h3>Delivery Address</h3>
                          <h4>{orderDetails.name}</h4>
                          <p>{`${orderDetails.city}, ${orderDetails.district}, ${orderDetails.houseNo} ${orderDetails.address} - ${orderDetails.pincode}, ${orderDetails.state}`}</p>
                          <p>
                            <strong>Phone number :</strong>{" "}
                            {orderDetails.phone_no}
                          </p>
                        </div>
                        <div className="col-sm-4 col-md-4">
                          <h3>Order Number</h3>
                          <p>{orderDetails.orderNumber}</p>
                        </div>
                        <div className="col-sm-2 col-md-2">
                          <h4>Order Method</h4>
                          <p>{orderDetails.method}</p>
                        </div>
                        <div className="col-sm-2 col-md-2">
                          <h4>Order Date</h4>
                          <p>{formattedDate}</p>
                        </div>
                      </div>
                    </div>

                    <div className="border-top border-1 my-3 p-3">
                      <div className="row">
                        {orderDetails?.products?.map((item, i) => {
                          const orderProduct = item?.orderProduct;

                          const isDelivered =
                            orderProduct?.orderType === "delivered";
                          const orderDate = new Date(orderDetails?.createdAt);
                          const currentDate = new Date();
                          const timeDifference =
                            (currentDate - orderDate) / (1000 * 60 * 60);
                          const canReturn = isDelivered && timeDifference <= 24;
                          const isInitiate =
                            orderProduct?.orderType === "initiate";

                          // Get commission amount
                          const commissionAmount = calculateCommission(
                            orderDetails.id,
                            item.id
                          );

                          return (
                            <div className="col-sm-4 col-md-4" key={i}>
                              <div className="orderpicsecwrap orderpricedetails">
                                <div className="picsec">
                                  <img
                                    className="img-responsive img-circle w-100"
                                    src={
                                      process.env.REACT_APP_API_URL +
                                      process.env.REACT_APP_product_IMAGE_URL +
                                      item.image[0]
                                    }
                                    alt="sell item"
                                  />
                                </div>
                                <div className="picsectext">
                                  <div className="boxsize">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <h2>{item.title}</h2>
                                      <div></div>
                                    </div>
                                    <div>
                                      SKU: {item.sku}
                                      <span className="bg-light p-1 mx-2 rounded-3"></span>
                                      Quantity: {orderProduct.quantity}
                                    </div>
                                    <div>
                                      <span>
                                        Status : {orderProduct.orderType}
                                      </span>
                                    </div>
                                    <span>₹{item.update_price}</span>
                                    <div>
                                      <strong>Commission:</strong> ₹{Number(commissionAmount).toFixed(2) * orderProduct.quantity}
                                    </div>
                                    <div className="mt-2">
                                      <button
                                        style={{
                                          marginRight: "10px",
                                          padding: "8px 15px",
                                          borderRadius: "5px",
                                          backgroundColor: canReturn
                                            ? "#007bff"
                                            : "#dcdcdc",
                                          color: canReturn
                                            ? "white"
                                            : "#999999",
                                          border: "none",
                                          cursor: canReturn
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                        onClick={() =>
                                          openModal("Return", item)
                                        }
                                        disabled={!canReturn}
                                      >
                                        Return
                                      </button>
                                      <button
                                        style={{
                                          padding: "8px 15px",
                                          borderRadius: "5px",
                                          backgroundColor: isInitiate
                                            ? "#28a745"
                                            : "#dcdcdc",
                                          color: isInitiate
                                            ? "white"
                                            : "#999999",
                                          border: "none",
                                          cursor: isInitiate
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                        onClick={() =>
                                          openModal("Cancel", item)
                                        }
                                        disabled={!isInitiate}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                    {/* Modal for Return/Cancel */}
                                    <Modal
                                      show={isModalOpen}
                                      onHide={closeModal}
                                      centered
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>
                                          {modalType} Reason
                                        </Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body
                                        style={{ backgroundColor: "#f2f2f2" }}
                                      >
                                        <p>
                                          Please select a reason for the{" "}
                                          <strong>
                                            {modalType.toLowerCase()}:
                                          </strong>
                                        </p>
                                        <ul className="p-0">
                                          {(modalType === "Return"
                                            ? reasonsForReturn
                                            : reasonsForCancel
                                          ).map((reason, index) => (
                                            <li
                                              key={index}
                                              style={{
                                                listStyle: "none",
                                                paddingTop: "4px",
                                                paddingBottom: "4px",
                                              }}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="radio"
                                                name="reason"
                                                aria-label="Radio button for following text input"
                                                value={reason}
                                                checked={selectedReason === reason}
                                                onChange={() =>
                                                  setSelectedReason(reason)
                                                }
                                                style={{
                                                  appearance: "none",
                                                  marginRight: "10px",
                                                  width: "22px",
                                                  height: "22px",
                                                  borderRadius: "50%",
                                                  border: "2px solid black",
                                                  backgroundColor:
                                                    selectedReason === reason
                                                      ? "White"
                                                      : "white",
                                                  display: "inline-block",
                                                  cursor: "pointer",
                                                  boxShadow:
                                                    selectedReason === reason
                                                      ? "0 0 0 6px green inset"
                                                      : "none",
                                                }}
                                              />
                                              <span
                                                style={{
                                                  marginTop: "3px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                {" "}
                                                {reason}
                                              </span>
                                            </li>
                                          ))}
                                        </ul>
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={closeModal}
                                        >
                                          Close
                                        </Button>
                                        <Button
                                          variant="primary"
                                          onClick={handleSubmitReason}
                                        >
                                          Submit
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default OrderDetails;
